import "swiper/css";
import "swiper/css/autoplay";
import 'swiper/css/navigation';


import { Autoplay, Navigation } from 'swiper/modules';

import { Swiper, SwiperSlide } from "swiper/react";


import { Link } from "react-router-dom";
import { PortableText } from '@portabletext/react';
import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';


// import gizmoImg from '';


function TextSlides() {
     const images = useImages();
      
          if (!Array.isArray(images) || !images.length) {
              return <div></div>;
          }
      
          // Helper function to find an image by title
          const getImageByTitle = (title) => {
              return images.find((image) => image.title === title);
          };
      
          // Fetch specific images by their titles
      
          const slideone = getImageByTitle('Convert Case');
          const slidetwo = getImageByTitle('Find Replace Text');
      



    return (

        <div className=" ">
            <Swiper
                breakpoints={{


                    520: {
                        // Mobile: 500px and up
                        slidesPerView: 1.5,
                    },
                 
                    1400: {
                        // Mobile: 768px and up
                        slidesPerView: 4,
                    },

                    1200: {
                        // Mobile: 768px and up
                        slidesPerView: 3,
                    },

                    800: {
                        slidesPerView: 2.5,
                    },


                }}
                spaceBetween={20}
                loop={true}
                modules={[Autoplay, Navigation]}
                navigation={{
                    prevEl: '.custom-prev',
                    nextEl: '.custom-next',
                }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                className="mySwiper"
            >

             
                <SwiperSlide>   <Link to="/text-gizmo/convert-case" >
                   <div className="gizmo-card">
                                  <div className="gizmo-img">
                                    {slideone && slideone.file && slideone.file.asset && (
                                      <img
                                        src={urlFor(slideone.file.asset)}
                                        alt={slideone.altText || 'Sanity Image'}
                                        className="img-fluid"
                                      />
                                    )}
                                  </div>
                                  <div className="gizmo-details-well">
                                    <div className="gizmo-title">
                                      {slideone?.sectionTitle || 'Default Title'}
                                    </div>
                                    <div className="gizmo-desc">
                                      {slideone?.content ? (
                                        <PortableText
                                          value={slideone.content}
                                          components={{
                                            block: {
                                              normal: ({ children }) => <p>{children}</p>,
                                              h1: ({ children }) => <h1>{children}</h1>,
                                              h2: ({ children }) => <h2>{children}</h2>,
                                            },
                                            marks: {
                                              link: ({ children, value }) => (
                                                <a
                                                  href={value.href}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-blue-500"
                                                >
                                                  {children}
                                                </a>
                                              ),
                                            },
                                          }}
                                        />
                                      ) : 'Default description'}
                                    </div>
                                    <Link to="/text-gizmo" className="gizmo-card-link">
                                      {slideone?.btnlabel || 'Learn More'}
                                    </Link>
                                  </div>
                                </div>
                </Link></SwiperSlide>
                <SwiperSlide>   <Link to="/text-gizmo/replace-text" >
                <div className="gizmo-card">
                <div className="gizmo-img">
                  {slideone && slideone.file && slideone.file.asset && (
                    <img
                      src={urlFor(slideone.file.asset)}
                      alt={slideone.altText || 'Sanity Image'}
                      className="img-fluid"
                    />
                  )}
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                    {slidetwo?.sectionTitle || 'Default Title'}
                  </div>
                  <div className="gizmo-desc">
                    {slidetwo?.content ? (
                      <PortableText
                        value={slidetwo.content}
                        components={{
                          block: {
                            normal: ({ children }) => <p>{children}</p>,
                            h1: ({ children }) => <h1>{children}</h1>,
                            h2: ({ children }) => <h2>{children}</h2>,
                          },
                          marks: {
                            link: ({ children, value }) => (
                              <a
                                href={value.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500"
                              >
                                {children}
                              </a>
                            ),
                          },
                        }}
                      />
                    ) : 'Default description'}
                  </div>
                  <Link to="/text-gizmo" className="gizmo-card-link">
                    {slidetwo?.btnlabel || 'Learn More'}
                  </Link>
                </div>
              </div>
                </Link></SwiperSlide>
              


            </Swiper>
            <div className="arrow-grp">
                <div className="swiper-button-prev custom-prev"></div>
                <div className="swiper-button-next custom-next"></div>
            </div>
        </div>

    );
};
export default TextSlides;